// import { SignIn } from "@clerk/nextjs";

'use client';

import { useState } from 'react';

import { Stepper } from '@/components/global/Stepper';

import { Account } from './_components/Account';
import Info from './_components/Info';
import OTP from './_components/OTP';
import Consent from '@/app/(auth)/(center)/sign-up/_components/Consent';
import { useAuthStore } from '@/presentation/hooks/useStores'; // export enum SignUpState {

// export enum SignUpState {
//   Account,
//   OTP,
//   Info,
//   Marketing,
//   Tnc,
// }

export default function SignUpPage() {
  const authStore = useAuthStore();
  const partnerRequiresOtp = authStore.partnerAuthSession?.requiresOtp ?? false;
  const needsOtpVerification = !authStore.hasPartnerSession || partnerRequiresOtp;

  const process = needsOtpVerification
    ? ['Consent', 'Account', 'Verify Phone', 'Employment Info']
    : ['Consent', 'Account', 'Employment Info'];
  const [stepNumber, setStepNumber] = useState(0);

  const handleIndexChange = (_stepNumber: number) => {
    setStepNumber(_stepNumber);
  };
  const totalProcess = process.length - 1;

  return (
    <section className="flex w-screen flex-col justify-center p-6 sm:w-fit md:px-11 lg:px-20">
      {stepNumber != 0 && (
        <Stepper
          stepNumber={stepNumber}
          process={process}
          onStepChange={handleIndexChange}
        />
      )}
      <div className={'mt-4 space-y-6 sm:max-w-[430px] md:mt-8 mx-auto'}>
        {(() => {
          if (stepNumber === 0) {
            return (
              <Consent
                index={0}
                totalProcess={totalProcess}
                onIndexChange={handleIndexChange}
              />
            );
          }

          if (stepNumber === 1) {
            return (
              <Account
                index={1}
                totalProcess={totalProcess}
                onIndexChange={handleIndexChange}
              />
            );
          }

          if (needsOtpVerification) {
            if (stepNumber === 2) {
              return (
                <OTP
                  index={2}
                  totalProcess={totalProcess}
                  onIndexChange={handleIndexChange}
                  purpose={'SIGNUP'}
                />
              );
            }

            if (stepNumber === 3) {
              return (
                <Info
                  index={3}
                  totalProcess={totalProcess}
                  onIndexChange={handleIndexChange}
                />
              );
            }
          } else {
            if (stepNumber === 2) {
              return (
                <Info
                  index={2}
                  totalProcess={totalProcess}
                  onIndexChange={handleIndexChange}
                />
              );
            }
          }

          // Fallback: restart flow
          return (
            <Consent
              index={0}
              totalProcess={totalProcess}
              onIndexChange={handleIndexChange}
            />
          );
        })()}
      </div>
    </section>
  );
}
